"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSCPNIComponent = void 0;
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const hscpni_service_1 = require("../../services/hscpni.service");
const account_service_1 = require("../../services/account.service");
const cpni_component_1 = require("../../cpni/cpni.component");
const generic_content_service_1 = require("../../services/generic.content.service");
class CSHSCPNIComponent extends cpni_component_1.CSCPNIComponent {
    constructor(modalService, genericContentService, accountService, cpniHSService) {
        super(modalService, genericContentService, accountService);
        this.cpniHSService = cpniHSService;
    }
    open(content) {
        this.modelRef = this.modalService.open(content, { windowClass: 'dark-modal' });
        this.errorMsg = '';
        this.cpin = null;
        // this.isCpinRequired(true);
    }
    getCPINContent() {
        this.loading = true;
        this.genericContentService.getGenericContent('/generic/disclaimer/cpniInformation')
            .subscribe((content) => {
            this.cpniInformationContent = content;
            this.loading = false;
        }, (err) => {
            this.modelError = err;
            this.loading = false;
        });
    }
    isCpinRequired() {
        this.cpniHSService.cpinHsCheck(this.expressPay)
            .subscribe((res) => {
            this.check = res;
            // Check CPNI BSI API will return 204 for CPNI required accounts
            if (res.error !== undefined && res.error.length > 0) {
                this.accountService.getFiberExpressAccDetails(this.expressPay).subscribe((data) => {
                    this.getFiberExpressAccDetailsSuccess(data);
                });
            }
            else {
                if (this.check.cpniRequired) {
                    this.open(this.cpniModelContent);
                }
                else {
                    this.callAjax.emit(true);
                }
            }
            // this.resetPin();
        }, (err) => {
            this.modelError = err;
            this.loading = false;
            if (this.modelError !== undefined && this.modelError.length > 0) {
                this.accountService.getFiberExpressAccDetails(this.expressPay).subscribe((data) => {
                    this.getFiberExpressAccDetailsSuccess(data);
                });
            }
        });
    }
    getFiberExpressAccDetailsSuccess(res) {
        if (res) {
            this.myServices = res.serviceSubscriptionDetails;
            for (let i = 0; i < this.myServices.length; i++) {
                if (this.myServices[i].planFiberName.indexOf('PHONE') >= 0) {
                    this.isPhoneService = true;
                    break;
                }
            }
            if (this.isPhoneService) {
                this.open(this.cpniModelContent);
            }
        }
    }
    resetPin(ssn) {
        this.loading = true;
        // added check for express pay
        const content = {
            'pin': ssn.ssn,
            'isExpressPay': this.expressPay,
        };
        this.cpniHSService.createHsPin(content)
            .subscribe((res) => {
            this.created = res;
            this.isnewPinGenerationSusccess = true;
            this.loading = false;
            if (res.error !== undefined) {
                this.errorMsg = res.error;
            }
        }, (err) => {
            this.showGenericError(err);
        });
    }
    triggerAction() {
        this.modelError = null;
        this.isCpinRequired();
    }
    validatePin(value) {
        this.loading = true;
        // added check for express pay
        const content = {
            'pin': value.pin,
            'isExpressPay': this.expressPay,
        };
        this.cpniHSService.validateHs(content)
            .subscribe((res) => {
            this.validation = res;
            this.loading = false;
            if (res.error !== undefined) {
                this.errorMsg = res.error;
            }
            else {
                this.callAjax.emit(true);
                this.errorMsg = '';
                this.modelRef.close();
            }
        }, (err) => {
            this.showGenericError(err);
        });
    }
    showGenericError(err) {
        this.modelError = err;
        this.errorMsg = err;
        this.loading = false;
    }
    hsCPNIValidation(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : ((event.charCode >= 48 && event.charCode <= 57)
            || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122));
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    resetErrors() {
        this.errorMsg = null;
        this.modelError = null;
    }
}
exports.CSHSCPNIComponent = CSHSCPNIComponent;
//# sourceMappingURL=hscpni.component.js.map